module.exports = __webpack_public_path__ + "412c9e475898b057009e8a4e7d80b349.svg";